import React from "react";
import { Box, Text, Spinner, Badge, HStack } from "@chakra-ui/react";
import { BillerPlan } from "features/bbps/biller/billerFlowTypes";
import { usePaymentFlowStore } from "hooks/Bbps/paymentFlow/usePaymentFlowStore";

interface PlanListProps {
  plans: BillerPlan[];
  loading: boolean;
  errorMessage?: string;
  disabled?: boolean;
}

const BillerPlanList: React.FC<PlanListProps> = ({
  plans,
  loading,
  errorMessage,
  disabled,
}) => {
  const { selectedPlan, setPlan, setStep } = usePaymentFlowStore();

  if (loading) {
    return (
      <Box textAlign="center" py={4}>
        <Spinner size="sm" />
      </Box>
    );
  }

  if (errorMessage) {
    return (
      <Box fontSize="sm" color="red.500" py={2}>
        {errorMessage}
      </Box>
    );
  }

  if (!plans.length) {
    return (
      <Box fontSize="sm" color="gray.500" py={2}>
        No plans available.
      </Box>
    );
  }

  return (
    <Box
      w="100%"
      maxH="70vh"
      overflowY="auto"
      pr={1} // for scrollbar gap
    >
      <Box
        as="ul"
        m={0}
        p={0}
        listStyleType="none"
        display="flex"
        flexDirection="column"
        gap={3}
        // minH={"20vh"}
        // maxH="60vh" // optionally scrollable
        // overflowY="auto"
      >
        {plans.map((p) => {
          const isActive = selectedPlan?.id === p.id;
          const tags = p.planadditionalinfo?.Tag ?? [];

          return (
            <Box
              as="li"
              key={p.id}
              w="100%"
              borderWidth="1px"
              borderRadius="md"
              p={3}
              // cursor="pointer"
              // onClick={() => {
              //   setPlan(p);
              //   setStep("SELECT_PLAN");
              // }}
              // bg={isActive ? "blue.50" : "white"}
              // _hover={{ bg: isActive ? "blue.100" : "gray.50" }}
              // overflow="hidden" //  card se bahar na jaye
              cursor={disabled ? "not-allowed" : "pointer"}
              onClick={() => {
                if (disabled) return;
                setPlan(p);
                setStep("SELECT_PLAN");
              }}
              bg={isActive ? "blue.50" : "white"}
              _hover={disabled ? {} : { bg: isActive ? "blue.100" : "gray.50" }}
              opacity={disabled ? 0.6 : 1}
              overflow="hidden"
            >
              <HStack justify="space-between" mb={1} align="flex-start">
                <Text fontWeight="600" fontSize="sm" whiteSpace="nowrap">
                  ₹{p.amountinrupees}
                </Text>
                <Badge size="sm" colorScheme="blue" flexShrink={0}>
                  {p.categorytype}
                </Badge>
              </HStack>

              <Text
                fontSize="xs"
                color="gray.700"
                mt={1}
                // lineClamp="3"
                whiteSpace="normal"
                wordBreak="break-word"
              >
                {p.plandescription}
              </Text>

              {tags.length > 0 && (
                <HStack mt={2} gap={1} flexWrap="wrap" alignItems="flex-start">
                  {tags.map((t) => (
                    <Badge
                      key={t.paramName}
                      variant="subtle"
                      fontSize="0.65rem"
                      maxW="100%"
                      whiteSpace="normal"
                      wordBreak="break-word"
                    >
                      {t.paramName}: {t.paramValue}
                    </Badge>
                  ))}
                </HStack>
              )}
            </Box>
          );
        })}
      </Box>
    </Box>
  );
};

export default BillerPlanList;
